module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"footer":{"payment_mode":"Modes de paiement"}},"en":{"footer":{"payment_mode":"Payment methods"}},"pt":{"footer":{"payment_mode":"Modos de pagamento"}},"es":{"footer":{"payment_mode":"Métodos de pago"}},"de":{"footer":{"payment_mode":"Zahlungsarten"}},"it":{"footer":{"payment_mode":"Modalità di pagamento"}},"nl":{"footer":{"payment_mode":"Betalingsmogelijkheden"}}}')
  delete Component.options._Ctor
}
